import { Box, Container } from "@chakra-ui/react"

export const FullPageLayout = ({ children, ...boxProps }) => {
	return (
		<Box {...boxProps}>
			<Container maxW='1170px' p={0}>
				{children}
			</Container>
		</Box>
	)
}